import { pnlPct, riskAction } from "./msiRiskManager";

function fmt(n, d = 2) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
  return Number(n).toFixed(d);
}

export function syndicationAlert(position) {
  const action = riskAction(position);
  const pnl = pnlPct(position);

  if (!["EXIT", "TAKE_PROFIT", "CUT_LOSS", "LOCK_PROFITS", "SCALE_OUT"].includes(action)) {
    return null;
  }

  return `🚨 PWG MSI POSITION ALERT

${position.ticker} ${position.contract}
Action: ${action}

Stock Entry: $${fmt(position.stock_entry)}
Stock Now: $${fmt(position.stock_current)}

Option Entry: $${fmt(position.option_entry)}
Option Now: $${fmt(position.option_current)}
P/L: ${pnl >= 0 ? "+" : ""}${fmt(pnl, 1)}%

Target: ${position.target}
DTE: ${position.dte}
Expires: ${position.expiration_date}

Reason:
${action === "EXIT" ? "Target hit with low DTE. Thesis complete." : "Risk manager action triggered."}`;
}
